var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-with-text"},[_c('strong',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" \n  "),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }